import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

// True when any locally-managed operator overlay (an APM job/work drawer, an
// FAI prompt, the unattended sign-in prompt, the enter-setup/prod transition,
// the control-action modal, etc.) has registered itself open via
// actionSetOperatorOverlayOpen / useRegisterOperatorOverlay.
const getAnyOverlayOpen = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return (workOrderManagement.openOverlayIds || []).length > 0;
  }
);

export { getAnyOverlayOpen };
